import { render } from "./OrdersModal.vue?vue&type=template&id=1c70e53c"
import script from "./OrdersModal.vue?vue&type=script&lang=js"
export * from "./OrdersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__